import {
  UPDATE_LOADING_STATUS,
  FETCH_APPMANGE_DATA_LIST,
} from "../actions/appMange";

const defVal = {
  dataListLoading: false,
  dataList: [],
  dataListTotal: 0,
};

export default (state = defVal, action) => {
  switch (action.type) {
    case UPDATE_LOADING_STATUS:
      return Object.assign({}, state, {
        dataListLoading: action.loading
      });

    case FETCH_APPMANGE_DATA_LIST:
      return Object.assign({}, state, {
        dataList: action.dataList,
        dataListTotal: action.dataListTotal,
      });

    default:
      return state;
  }
};
